export const CHANGE_AMOUNT = 'CHANGE_AMOUNT';

export const changeAmount = amount => ({ type: CHANGE_AMOUNT, payload: amount });
